@if (selectDropdownForm) {
<form [formGroup]="selectDropdownForm">
  <aw-select-menu
    [ariaLabel]="'Single Select Menu'"
    formControlName="selectOption"
    [singleSelectListItems]="options()"
  >
    <aw-form-field-label [required]="required()">
      {{ title() }}
    </aw-form-field-label>

    @if (required() && selectDropdownForm.controls['selectOption'].touched &&
    selectDropdownForm.controls['selectOption'].errors?.['required']) {
    <aw-form-message type="error"> Please select an option </aw-form-message>
    }
  </aw-select-menu>
</form>
}
